import { IAdvisor } from "./Advisor";
import { IProject } from "./Project";
import { IUser } from "./User";

export enum FeedbackType {
    GENERAL = "general",
    PRODUCT = "product",
    STRATEGY = "strategy",
    MARKET = "market",
    OPERATIONS = "operations",
    FUNDRAISING = "fundraising"
}

export enum FeedbackStatus {
    DRAFT = "draft",
    SUBMITTED = "submitted",
    REVIEWED = "reviewed",
    ARCHIVED = "archived"
}

export interface IFeedback {
    id: number;
    uuid: string;
    advisor: IAdvisor;
    project: IProject;
    title: string;
    content: string;
    type: FeedbackType;
    status: FeedbackStatus;
    helpful_count: number;
    is_anonymous: boolean;
    priority?: number;
    tags?: string[];
    internal_notes?: string;
    helpful_marks?: any[]; // Avoid circular dependency
    submitted_at?: string;
    reviewed_at?: string;
    reviewed_by?: IUser;
    created_at: string;
    updated_at: string;
} 